import PropTypes from 'prop-types'
import React from 'react'

import Icon from 'components/Icon'
import { BoxBase, Col, RowIndented } from 'styles/components/layout'
import { TextDisclaimer } from 'styles/components/typography'

import { Wrapper, IconWrapper } from './styles'

/**
 * CartDisclaimer
 *
 * @param {object} props - properties of component
 * @returns {node} CartDisclaimer
 */
const CartDisclaimer = props => {
  const { content, isWide, mobile } = props
  const disclaimerContent = React.useMemo(() => {
    if (!mobile) {
      return content
    }

    return content.replace(
      /заболеваний\.\s*Не&nbsp;рекомендуется/u,
      'заболеваний.<br/>Не&nbsp;рекомендуется',
    )
  }, [content, mobile])

  if (isWide) {
    return (
      <Wrapper>
        <IconWrapper>
          <Icon id="btn_info" color="black" />
        </IconWrapper>
        <TextDisclaimer dangerouslySetInnerHTML={{ __html: disclaimerContent }} />
      </Wrapper>
    )
  }

  return (
    <BoxBase>
      <RowIndented indent={{ xs: 0, md: 0 }} justifyContent="center">
        <Col width={{ xs: 1, lg: isWide ? 1 : 8 / 12 }}>
          <Wrapper>
            <IconWrapper>
              <Icon id="btn_info" color="black" />
            </IconWrapper>
            <TextDisclaimer dangerouslySetInnerHTML={{ __html: disclaimerContent }} />
          </Wrapper>
        </Col>
      </RowIndented>
    </BoxBase>
  )
}

CartDisclaimer.propTypes = {
  /** Text of disclaimer */
  content: PropTypes.string.isRequired,
  isWide: PropTypes.bool,
  mobile: PropTypes.bool,
}

export default React.memo(CartDisclaimer)
